import { type SVGAttributes } from "react";

export function BagIcon({
  empty = true,
  ...props
}: { empty?: boolean } & SVGAttributes<SVGSVGElement>) {
  return (
    <svg
      fill="none"
      height="24"
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6 9C6 8.44771 6.44772 8 7 8H17C17.5523 8 18 8.44772 18 9V18C18 18.5523 17.5523 19 17 19H7C6.44772 19 6 18.5523 6 18V9Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M9 7C9 5.89543 9.89543 5 11 5H13C14.1046 5 15 5.89543 15 7V8H9V7Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      {!empty ? (
        <>
          <rect
            fill="url(#paint0_linear_320_4175)"
            height="6"
            rx="3"
            transform="matrix(1 0 0 -1 9 16.5)"
            width="6"
          />
          <defs>
            <linearGradient
              gradientUnits="userSpaceOnUse"
              id="paint0_linear_320_4175"
              x1="3"
              x2="3"
              y1="0"
              y2="6"
            >
              <stop stopColor="#FD0021" />
              <stop offset="1" stopColor="#E6037E" />
            </linearGradient>
          </defs>
        </>
      ) : null}
    </svg>
  );
}
